<p-toast position="top-right"></p-toast>

<div class="profile-container">
  <div class="profile-header">
    <div class="header-left">
      <h1>Mon Profil</h1>
      <p>Gérez vos informations et sécurité</p>
    </div>
    <div class="header-right">
      <p-tag [value]="getRoleBadge()" [severity]="getRoleSeverity()" styleClass="role-tag"></p-tag>
    </div>
  </div>

<div class="profile-content">
    <!-- Photo de Profil -->
    <div class="section photo-section">
      <h2 class="section-title">
        <i class="pi pi-image"></i>
        Photo de Profil
      </h2>
      
      <div class="photo-container">
        <div class="photo-display">
          <p-avatar 
            *ngIf="getPhotoUrl()" 
            [image]="getPhotoUrl()" 
            size="xlarge" 
            shape="circle"
            styleClass="profile-avatar"
          ></p-avatar>
          <p-avatar 
            *ngIf="!getPhotoUrl()" 
            [label]="getUserInitials()" 
            size="xlarge" 
            shape="circle"
            styleClass="profile-avatar-initials"
          ></p-avatar>
          
          <div class="photo-actions">
            <p-fileUpload
              mode="basic"
              chooseLabel="Choisir une photo"
              [auto]="false"
              [maxFileSize]="5242880"
              accept="image/*"
              (onSelect)="onFileSelect($event)"
              [disabled]="isUploadingPhoto"
              styleClass="upload-btn"
            ></p-fileUpload>
            
            <button 
              pButton 
              icon="pi pi-trash"
              label="Supprimer"
              class="p-button-danger p-button-outlined delete-photo-btn"
              (click)="deletePhoto()"
              [disabled]="!photoUrl || isDeletingPhoto"
              [loading]="isDeletingPhoto"
              *ngIf="photoUrl"
            ></button>
          </div>
          
          <p class="photo-help-text">
            <i class="pi pi-info-circle"></i> 
            Image JPEG, PNG ou GIF. Taille maximale: 5 MB
          </p>
        </div>
      </div>
    </div>

    <!-- Informations Personnelles -->
    <div class="section">
      <h2 class="section-title">
        <i class="pi pi-user"></i>
        Informations Personnelles
      </h2>
      
      <div class="form-grid">
        <div class="form-group">
          <label for="username">
            <i class="pi pi-user"></i>
            Nom d'utilisateur
            <span class="required">*</span>
          </label>
          <input 
            id="username" 
            type="text" 
            pInputText 
            [(ngModel)]="username"
            placeholder="Votre nom d'utilisateur"
          />
        </div>

        <div class="form-group">
          <label for="email">
            <i class="pi pi-envelope"></i>
            Email
            <span class="required">*</span>
          </label>
          <input 
            id="email" 
            type="email" 
            pInputText 
            [(ngModel)]="email"
            placeholder="votre.email@exemple.com"
          />
        </div>

        <div class="form-group">
          <label for="phone">
            <i class="pi pi-phone"></i>
            Téléphone mobile
          </label>
          <input 
            id="phone" 
            type="tel" 
            pInputText 
            [(ngModel)]="phone"
            placeholder="06 12 34 56 78"
          />
        </div>

        <div class="form-group">
          <label for="phoneFixe">
            <i class="pi pi-phone"></i>
            Téléphone fixe
          </label>
          <input 
            id="phoneFixe" 
            type="tel" 
            pInputText 
            [(ngModel)]="phoneFixe"
            placeholder="01 83 81 00 93"
          />
        </div>
      </div>

      <div class="form-actions">
        <button 
          pButton 
          label="Annuler" 
          icon="pi pi-times"
          class="p-button-text cancel-btn"
          (click)="resetProfile()"
          [disabled]="!hasProfileChanges() || isSavingProfile"
        ></button>
        <button 
          pButton 
          label="Enregistrer" 
          icon="pi pi-check"
          class="save-btn"
          (click)="saveProfile()"
          [loading]="isSavingProfile"
          [disabled]="!hasProfileChanges()"
        ></button>
      </div>
    </div>

    <!-- Changement de Mot de Passe -->
    <div class="section">
      <h2 class="section-title">
        <i class="pi pi-lock"></i>
        Changement de Mot de Passe
      </h2>

      <p-message 
        *ngIf="passwordMessage" 
        [severity]="passwordMessage.severity" 
        [text]="passwordMessage.text"
        styleClass="mb-3 w-full"
      ></p-message>

      <div class="form-grid">
        <div class="form-group full-width">
          <label for="currentPassword">
            <i class="pi pi-key"></i>
            Mot de passe actuel
            <span class="required">*</span>
          </label>
          <p-password 
            id="currentPassword"
            [(ngModel)]="currentPassword"
            [feedback]="false"
            [toggleMask]="true"
            placeholder="Entrez votre mot de passe actuel"
            styleClass="w-full"
            inputStyleClass="w-full"
          ></p-password>
        </div>

        <div class="form-group">
          <label for="newPassword">
            <i class="pi pi-lock"></i>
            Nouveau mot de passe
            <span class="required">*</span>
          </label>
          <p-password 
            id="newPassword"
            [(ngModel)]="newPassword"
            [feedback]="true"
            [toggleMask]="true"
            placeholder="Minimum 8 caractères"
            styleClass="w-full"
            inputStyleClass="w-full"
            [strongRegex]="'^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'"
          >
            <ng-template pTemplate="footer">
              <p-divider></p-divider>
              <p class="password-info">Conseils pour un mot de passe sécurisé:</p>
              <ul class="password-requirements">
                <li>Au moins 8 caractères</li>
                <li>Mélange de majuscules et minuscules</li>
                <li>Au moins un chiffre</li>
                <li>Au moins un caractère spécial</li>
              </ul>
            </ng-template>
          </p-password>
        </div>

        <div class="form-group">
          <label for="confirmPassword">
            <i class="pi pi-check-circle"></i>
            Confirmer le mot de passe
            <span class="required">*</span>
          </label>
          <p-password 
            id="confirmPassword"
            [(ngModel)]="confirmPassword"
            [feedback]="false"
            [toggleMask]="true"
            placeholder="Confirmez votre nouveau mot de passe"
            styleClass="w-full"
            inputStyleClass="w-full"
          ></p-password>
        </div>
      </div>

      <div class="form-actions">
        <button 
          pButton 
          label="Changer le mot de passe" 
          icon="pi pi-lock"
          class="change-password-btn"
          [disabled]="!isPasswordFormValid() || isChangingPassword"
          [loading]="isChangingPassword"
          (click)="changePassword()"
        ></button>
      </div>
    </div>
  </div>
</div>
